import { styled } from "goober";
import type { ReactNode } from "react";
import { Text } from "./Text";

export type StatusBadgeColor =
  | "green"
  | "orange"
  | "red"
  | "teal"
  | "sky"
  | "purple"
  | "yellow"
  | "gray";

const StatusBadgeRoot = styled("span")`
  display: inline-flex;
  align-items: center;
  height: 16px;
  padding: 0 6px;
  border-radius: 8px;
  flex-shrink: 0;
  white-space: nowrap;
`;

export function StatusBadge({
  color,
  children,
}: {
  color: StatusBadgeColor;
  children: ReactNode;
}) {
  return (
    <StatusBadgeRoot
      style={{
        background: `var(--${color}-200)`,
        color: `var(--${color}-800)`,
      }}
    >
      <Text variant="text-smaller-md">{children}</Text>
    </StatusBadgeRoot>
  );
}
